import React from "react";

interface PracticeIconProps {
  stroke?: string;
  fill?: string;
  width?: string;
  height?: string;
}

const PracticeIcon: React.FC<PracticeIconProps> = ({
  stroke = "currentColor",
  fill = "none",
  width = "24",
  height = "24",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {/* Building/Clinic icon representing a practice */}
      <path d="M3 21h18" />
      <path d="M5 21V7l8-4v18" />
      <path d="M19 21V11l-6-4" />
      <path d="M9 9v.01" />
      <path d="M9 12v.01" />
      <path d="M9 15v.01" />
      <path d="M9 18v.01" />
    </svg>
  );
};

export default PracticeIcon;
